import { useState, type FormEvent } from 'react';
import { api, ApiError } from '../api';
import { Icon } from '../ui';

/** Sign-in screen in the V1 visual language (Nocturne card, field, primary button). */
export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('POST', '/api/v1/auth/login', { email, password });
      onSignedIn();
    } catch (err) {
      setError(err instanceof ApiError && err.status === 429 ? 'Too many attempts. Wait 15 minutes and try again.' : err instanceof ApiError && err.status === 401 ? 'Email or password is incorrect.' : 'Sign-in failed. Is the API running?');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--color-bg)', color: 'var(--color-text)', fontFamily: 'var(--font-body)', fontSize: 14, padding: 16 }}>
      <form onSubmit={submit} className="card elev-md" style={{ width: 'min(380px, 100%)', gap: 'var(--space-4)', padding: 'var(--space-8)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ width: 22, height: 22, borderRadius: 6, border: '1.5px solid var(--color-accent)', display: 'grid', placeItems: 'center', color: 'var(--color-accent)' }}><Icon name="ph-pulse" style={{ fontSize: 14 }} /></span>
          <span style={{ fontFamily: 'var(--font-heading)', fontWeight: 500, fontSize: 16, letterSpacing: '-0.01em' }}>Marketing OS</span>
        </div>
        <h4 style={{ margin: 0 }}>Sign in</h4>
        <div className="field"><label htmlFor="email">Email</label><input id="email" className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
        <div className="field"><label htmlFor="password">Password</label><input id="password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
        {error && <p style={{ margin: 0, fontSize: 13, color: 'var(--color-accent-300)' }}>{error}</p>}
        <button className="btn btn-primary" type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
    </div>
  );
}
